import { render, staticRenderFns } from "./searchlog.vue?vue&type=template&id=72228db4&"
import script from "./searchlog.vue?vue&type=script&lang=js&"
export * from "./searchlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports